import clsx from "clsx";
import React, { ReactNode } from "react";
import { ChannelConfig } from "./messageDrawerHelpers";

interface ChannelMessageSectionProps {
    title: string;
    channels?: ChannelConfig[];
    className?: string;
    children: ReactNode;
}

export const ChannelMessageSection = ({ title, channels, className, children }: ChannelMessageSectionProps) => (
    <div className={clsx("flex flex-col", className)}>
        <div className="flex items-center justify-between">
            <span className="text-md font-bold">{title}</span>
            {channels && <span className="font-bold">{channels.map((channel) => channel.label).join(", ")}</span>}
        </div>
        {children}
    </div>
);
